function requestDetailsDialog () {
  return {
    restrict: 'E',
    templateUrl: '/workflow/dialogs/request-details/request-details-dialog.html?$$REVISION$$'
  }
}

export { requestDetailsDialog }
